import {provideSingleton, lazyInject} from './../../services/inversify';
import { ApiService } from './../../services/api_service';


@provideSingleton(QueryGenService) // Diese Zeile definiert die Klasse bzw. eine Instanz davon als Service
export class QueryGenService {

    @lazyInject(ApiService) private apiService: ApiService;

    private lastModulesInfo: Array<any> = null;

    getModules(callback: (modules: Array<string>) =>  void) {
        this.apiService.call('getModules', {override: 1}, (data: string, suc: boolean) => {
            if ( suc ) {
                let result: Array<string>;
                try {
                    result = JSON.parse(data);
                } catch (e) {
                    console.error(data, e);
                }
                callback(result);
            }
        });
    }
    getModulesInfo(callback: (modules: Array<string>) =>  void) {
        this.apiService.call('getModulesInfo', {override: 1}, (data: string, suc: boolean) => {
            if ( suc ) {
                let result: Array<string>;
                try {
                    result = JSON.parse(data);
                } catch (e) {
                    console.error(data, e);
                }
                this.lastModulesInfo = result;
                callback(result);
            }
        });
    }
    public getModulName(key: string) {
        if (!this.lastModulesInfo) {
            return key;
        }
        const modulInfo = this.lastModulesInfo.find((mi: any) => mi !== null &&     mi.key === key);
        if (modulInfo) {
            return modulInfo.name;
        } else {
            return key;
        }
    }

}
